import { render, staticRenderFns } from "./Gamification.vue?vue&type=template&id=218f2cb8&"
import script from "./Gamification.vue?vue&type=script&lang=js&"
export * from "./Gamification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports